<template>
  <div class="expert-round-up">
    <div class="metadata">
      <UiComponentImage
        :alt="picture.alt"
        class="picture"
        :expected-size="68"
        :extra-params="{ fit: 'crop' }"
        :height="68"
        :source="picture.url"
        :width="68"
      />
      <div class="info">
        <div class="author">
          <UiComponentHeading
            as="paragraph"
            :level="3"
          >
            {{ name }}
          </UiComponentHeading>
          <AtomAnchor
            class="company"
            :to="url"
          >
            {{ company }}
          </AtomAnchor>
        </div>
        <div
          v-if="socialNetworks.length > 0"
          class="social-medias"
        >
          <AtomAnchor
            v-for="(network, index) in socialNetworks"
            :key="index"
            :to="network.url"
          >
            <img
              :alt="network.name"
              class="icon"
              height="19"
              loading="lazy"
              :src="network.icon"
              width="18"
            >
          </AtomAnchor>
          <svg
            class="hidden"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
          >
            <defs>
              <filter id="grey-600">
                <feColorMatrix
                  color-interpolation-filters="sRGB"
                  type="matrix"
                  values="0.36470588235 0 0 0 0
                    0 0.42745098039 0 0 0
                    0 0 0.47450980392 0 0
                    0 0 0 1 0 "
                />
              </filter>
            </defs>
          </svg>
        </div>
      </div>
    </div>
    <div
      class="quote"
      v-html="quote"
    />
  </div>
</template>

<script setup>
// Props
const props = defineProps({
  company: {
    required: true,
    type: String,
  },
  name: {
    required: true,
    type: String,
  },
  picture: {
    required: true,
    type: Object,
  },
  quote: {
    required: true,
    type: String,
  },
  socialMedias: {
    default() {
      return []
    },
    required: false,
    type: Array,
  },
  url: {
    required: true,
    type: String,
  },
})

// Computed Properties
const socialNetworks = computed(() => {
  return props.socialMedias.filter(media => media.url !== '')
})
</script>

<style lang="postcss" scoped>
.expert-round-up {
  @apply flex flex-col w-full h-auto;

  .metadata {
    @apply flex items-center w-full;

    .picture {
      @apply flex-shrink-0 rounded-full bg-grey-blue-600;
      height: 68px;
      width: 68px;
    }

    .info {
      @apply flex flex-col flex-grow ml-4;

      @screen md {
        @apply flex-row justify-between items-center ml-6;
      }

      .author {
        @apply flex flex-col;

        .h3 {
          @apply text-winter-green-900 !important;
        }

        .company {
          @apply mt-0 text-grey-blue-600;
        }
      }

      .social-medias {
        @apply flex h-5 mt-3 items-center;

        @screen md {
          @apply mt-0;
        }

        a {
          @apply flex w-5 h-5 justify-center items-center mx-1;

          &:first-child {
            @apply ml-0;
          }

          &:last-child {
            @apply mr-0;
          }

          .icon {
            filter: url(#grey-600);
          }
        }
      }
    }
  }

  .quote {
    @apply inline-flex mt-6 text-origin text-grey-blue-600 leading-7;

    :deep(p) {
      @apply inline;

      &::before {
        @apply inline;
        content: "“";
      }

      &::after {
        @apply inline;
        content: "”";
      }
    }
  }
}
</style>
